// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"ce17d848","265":"03c9b3e0","362":"91a6aa76","449":"af3950c9","527":"d460d590","576":"485264cf","644":"44702ff0","645":"6fd7dbdd","659":"48e319ae","719":"c148485d","736":"8d0a809a","744":"e1db1c51","827":"555567fc"}[chunkId] + ".chunk.js";
};